import Item from "./Item";
import Styled from "./index.styles";

export interface AccordionItem {
  title: React.ReactNode;
  desc: React.ReactNode;
  className?: string;
}

export default function Accordion({
  items,
  usesDivider,
  width,
  className,
}: {
  items: AccordionItem[];
  usesDivider?: boolean;
  /** 지정하지 않으면 100% */
  width?: string;
  className?: string;
}) {
  return (
    <Styled.container
      className={`${className ? className : ""} accordion`}
      width={width}
    >
      {items.map((item, i) => {
        return <Item data={item} key={i} usesDivider={usesDivider} />;
      })}
    </Styled.container>
  );
}
